module.exports = __webpack_public_path__ + "img/bank_detail.6683df49.png";